export const Role =  {
  admin:'admin',
  super_admin:'super_admin',
  mail:'mail',
  chat:'chat',
  services:'services',
  activities:'activities',
  departments:'departments',
  hr:'hr',
  customers:'customers',
  partners:'partners',
  finances:'finances',
  plan:'plan',
  todo:'todo',
  action:'action',
  feedback:'feedback',
  wiki:'wiki',
  it_support:'it_support',
  hr_support:'hr_support',
  op_support:'op_supportc',
  training:'training',
  payment:'payment',
  affiliate:'affiliate',
  refund:'refund',
  seller_reconcile:'seller_reconcile',
  admin_block:'admin_block',
  admin_department:'admin_department',
  admin_level:'admin_level',
  admin_position:'admin_position',
  admin_roles:'admin_roles',
  admin_user:'admin_user',
  affiliate_member:'affiliate_member',
  affiliate_order:'affiliate_order',
  affiliate_top:'affiliate_top',
  customers_marketing:'customers_marketing',
  customers_user:'customers_user',
  hubs_logistics:'hubs_logistics',
  hubs_wareHouse:'hubs_wareHouse',
  hubs_wareHouse_order:'hubs_wareHouse_order',
  hubs_wareHouse_users:'hubs_wareHouse_users',
  import_flow:'import_flow',
  import_plan:'import_plan',
  import_total:'import_total',
  manufacturing:'manufacturing',
  marketplace_marketing:'marketplace_marketing',
  move_amount:'move_amount',
  move_plan:'move_plan',
  o2o_order:'o2o_order',
  o2o_wareHouse:'o2o_wareHouse',
  order_index:'order_index',
  order_suburban:'order_suburban',
  order_urban:'order_urban',
  order_urban_ship:'order_urban_ship',
  plan_digitization:'plan_digitization',
  plan_gantt:'plan_gantt',
  plan_mkt:'plan_mkt',
  plan_my:'plan_my',
  plan_roadmap:'plan_roadmap',
  sell_bycalendar:'sell_bycalendar',
  sell_byday:'sell_byday',
  sell_bytype:'sell_bytype',
  sell_order:'sell_order',
  sell_plan:'sell_plan',
  stock_flow:'stock_flow',
  stock_fv:'stock_fv',
  stock_product:'stock_product',
  trading_offline_marketing:'trading_offline_marketing',
  trading_online_marketing:'trading_online_marketing',
  transport_onday:'transport_onday',
  warehouse_destruction:'warehouse_destruction',
  warehouse_inventory:'warehouse_inventory',
}
export const checkRole = (userRoles:any, menuRoles:any, roletype?:any)=>{
  if(roletype === 'admin') return true
  if(!menuRoles){
      return true 
  }else if(userRoles && menuRoles && userRoles?.some((userRole:any) => !!menuRoles?.find((item:any) => item === userRole))){
      return true
  }
  return false
}
